import { api } from 'src/utils/api';

export const loadActionsCountRequest = () => api.get('/dashboard/actions-count');

export const loadDealsCountRequest = () => api.get('/dashboard/deals');

export const loadDebtsStatusCountRequest = () => api.get('/dashboard/debts-status');

export const loadNextTransferRequest = () => api.get('/dashboard/transfer');

export const loadPaymentsCountRequest = (initDate, endDate) => api.get('/dashboard/payments', {
    params: {
        initDate,
        endDate,
    },
});

export const loadPendingDebtsRequest = () => api.get('/dashboard/pending-debts');

export const loadSurveysDashboardRequest =  () => api.get(`/dashboard/surveys`);